import { getMinimumSessionDetail, MinimumSessionDetail, getSessionDetail, SessionDetail } from '@fs/zion-rootstech'
import Agreement from './Agreement'
import AttachmentDetail from './AttachmentDetail'
import CategoryDataReference from './CategoryDataReference'
import { ConferencePromo, MinimumCreatorDetail } from './ConferencePromo'
import ContentVisibility from './ContentVisibility'
import CountryDataReference from './CountryDataReference'
import CountryTagDataReference from './CountryTagDataReference'
import { MinimumDashboardCreatorDetail } from './CreatorDetail'
import { MinimumExhibitorDetail } from './ExhibitorDetail'
import ObjectTypeDetail from './ObjectTypeDetail'
import SemaphoreTagDetail from './SemaphoreTagDetail'
import SessionTypeDetail from './SessionTypeDetail'
import TagDataReference from './TagDataReference'
import { LeadVideoDetail, VideoDetail } from './VideoDetail'

export { getMinimumSessionDetail, MinimumSessionDetail, getSessionDetail, SessionDetail }

export const getMinDashboardSessionDetail = (includeAudiences = false) => `
  ${Agreement}
  ${AttachmentDetail}
  ${MinimumDashboardCreatorDetail}
  ${MinimumExhibitorDetail}
  ${ObjectTypeDetail}
  ${VideoDetail}
  ${ContentVisibility}
  fragment MinDashboardSessionDetail on SessionDetail {
    agreements {
      ...Agreement
    }
    ${includeAudiences ? 'audiences { id }' : ''}
    conferenceYear
    contentLocale
    classSyllabus {
      ...AttachmentDetail
    }
    creators {
      ...MinimumDashboardCreatorDetail
    }
    date
    description
    exhibitors {
      ...MinimumExhibitorDetail
    }
    id
    publishSlides
    promo {
      contentType {
        ...ObjectTypeDetail
      }
      __typename

    sessionDifficulty
    sessionFormat
    sessionLocation
    }
    sessionUrl
    slideDeck {
      ...AttachmentDetail
    }
    title
    url
    video {
      ...VideoDetail
    }
    visibility {
      ...ContentVisibility
    }
  }
`

export const MinDashboardSessionDetail = getMinDashboardSessionDetail(false)

export const getDashboardSessionDetail = (includeAudiences = false) => `
  ${ConferencePromo}
  ${Agreement}
  ${CountryDataReference}
  ${CountryTagDataReference}
  ${CategoryDataReference}
  ${AttachmentDetail}
  ${SemaphoreTagDetail}
  ${ObjectTypeDetail}
  ${SessionTypeDetail}
  ${TagDataReference}
  ${ContentVisibility}
  ${MinimumCreatorDetail}
  ${MinimumExhibitorDetail}
  ${LeadVideoDetail}
  fragment DashboardSessionDetail on SessionDetail {
    additionalExperiences {
      ...ConferencePromo
    }
    agreements {
      ...Agreement
    }
    alternateLocales
    ${includeAudiences ? 'audiences { id }' : ''}
    categories {
      ...CategoryDataReference
    }
    classroomName
    classSyllabus {
      ...AttachmentDetail
    }
    conferenceYear
    contentLocale
    coSpeakers
    countries {
      ...CountryDataReference
    }
    countryTags {
      ...CountryTagDataReference
    }
    creators {
      ...MinimumCreatorDetail
    }
    date
    description
    downloadableResources {
      ...AttachmentDetail
    }
    exhibitors {
      ...MinimumExhibitorDetail
    }
    id
    publishSlides
    previousSessionLink
    promo {
      ...ConferencePromo
    }
    semaphoreTags {
      ...SemaphoreTagDetail
    }
    sessionApplication
    sessionDeliverable
    sessionDifficulty
    sessionFlexibility
    sessionFormat
    sessionId
    sessionLocation
    sessionOutline
    sessionPrerequisites
    sessionProblem
    sessionTechnology
    sessionUrl
    slate
    slideDeck {
      ...AttachmentDetail
    }
    speakerQualifications
    suggestedContent {
      ...ConferencePromo
    }
    tags {
      ...TagDataReference
    }
    title
    typeDetails {
      ...SessionTypeDetail
    }
    url
    video {
      ...LeadVideoDetail
    }
    visibility {
      ...ContentVisibility
    }
  }
`

export const DashboardSessionDetail = getDashboardSessionDetail(false)
